import React, { useEffect, useRef, useState } from 'react';
import { InputGroup, FormControl, Badge } from 'react-bootstrap';
import './InputFieldWithSuffix.css';
import Button from '../Button';
import InfoBar from '../InfoBars';
import CreateAndVerifyModal from '@pages/Beneficiary-block/WomenComponent/Child/CreateAndVerifyModal';
import VerificationIcon from './../../../assets/svg/checkmark-circle-green.svg';
import CustomiseAbhaAddressModal from '@pages/Beneficiary-block/WomenComponent/edit/CustomiseAbhaAddressModal';
import CustomiseAbhaAddressProceedModal from '@pages/Beneficiary-block/WomenComponent/edit/CustomiseAbhaAddressProceedModal';



interface Inputwithlabelprops {
  placeholder?:string,
  className?:string,
  labelName: string;
  type?: string;
  disabled?: boolean;
  btnDisabled?: boolean;
  required?: boolean,
  value:any,
  suffix:string,
  showCheckMark?:boolean,
  showButton?:boolean,
  onChange:(value: string,event?:any) => void;
  inputType?: 'general' | 'entered' | 'error' | 'success' | 'disabled';
  errorMessage?:string;
}
const InputFieldWithSuffix = ({
  placeholder,
  className,
  labelName,
  type,
  disabled,
  btnDisabled,
  required,
  value,
  suffix,
  showCheckMark,
  showButton,
  onChange,
  inputType,
  errorMessage
}: Inputwithlabelprops) => {
const [showModal, setShowModal] = useState<boolean>(false);
const [showProceedModal, setShowProceedModal] = useState<boolean>(false);

const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value,e);
};

const handleClick = () =>{
    setShowModal(true);
}

const closeModal = async(type:any) =>{
  if(type === 'close')
  {
    setShowModal(false);
  }else if(type === 'submit'){
    setShowModal(false);
    setShowProceedModal(true)
  }
}

const closeProceedModal = (type:string) =>{
  if(type === 'close'){
    setShowProceedModal(false);
  }
  else if (type === 'proceed'){
    setShowProceedModal(false);    
  }
}

  return (
    <div className='field-with-suffix-conatiner'>
      <label className={`label-name-from-parent ${required && 'yes'} ${disabled}`}>
        {labelName}
      </label>
      <div className='input-group-wrapper'>
        <InputGroup className='input-group-wrapper-parent'>
          <FormControl
            placeholder={placeholder}
            type={type}
            disabled={disabled}
            onChange={handleChange}
            value={value}
          />
          <InputGroup.Text>
            {suffix}
          </InputGroup.Text>
          {showCheckMark && <VerificationIcon className="check-icon"/>}
        </InputGroup>
        {showButton &&<Button
          onClick={handleClick}
          buttonName='Customize'
          colorType='primary'
          disabled={btnDisabled}
          id="customize-btn"
        />
        }
      </div>
      <div className="input_field_infoBars">
        {inputType === 'error' && (
          <InfoBar
            variant="danger"
            message={errorMessage ? errorMessage : ''}
            className="input_field_class"
          />)
        }
      </div>
      {showModal && <CustomiseAbhaAddressModal showModal={showModal} handleClose={closeModal} value={value} title={labelName} suffix={suffix} handleChange={onChange}/>}
      {showProceedModal && <CustomiseAbhaAddressProceedModal showModal={showProceedModal} handleClose={closeProceedModal}/>}
    </div>
  );
};
export default InputFieldWithSuffix;